import { render, staticRenderFns } from "./toTopKaiqi.vue?vue&type=template&id=70cf5db7&scoped=true"
import script from "./toTopKaiqi.vue?vue&type=script&lang=js"
export * from "./toTopKaiqi.vue?vue&type=script&lang=js"
import style0 from "./toTopKaiqi.vue?vue&type=style&index=0&id=70cf5db7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf5db7",
  null
  
)

export default component.exports